import React from 'react';
import { Box, ButtonV2, Flex, FlexProps, TextV2 } from '@withjoy/joykit';
import { ProgressRing } from '../ProgressRing';
import { Page } from '../../telemetry';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { useHandlePriceRangeClick } from '../../RegistryGiftCounts.controller';

interface PriceRangeProps extends FlexProps {
  title: string;
  targetGiftCount: number;
  completedGiftCount: number;
  isOpen: boolean;
  priceRangeQuery: string;
  page: Page;
  closeDrawer?: () => void;
}

export const PriceRangeV2 = ({ title, targetGiftCount, completedGiftCount, isOpen, priceRangeQuery, closeDrawer, page, ...props }: PriceRangeProps) => {
  const { t } = useTranslation('sharedComponents');
  const { shopNow } = t('registryGiftAdvisorV2');

  const { handlePriceRangeClick } = useHandlePriceRangeClick(page, () => closeDrawer?.());

  return (
    <Box
      {...props}
      width="100%"
      flexDirection="row"
      display="flex"
    >
      <ProgressRing
        isOpen={isOpen}
        currentGiftCount={completedGiftCount}
        progressPercent={(completedGiftCount / targetGiftCount) * 100}
        progressColor="#595959"
        countTextColor="#595959"
        typographyVariant="hed1"
      />
      <Flex
        flexDirection="column"
        marginLeft={3}
      >
        <TextV2
          fontSize={pxToRem(15)}
          color="mono10"
          display="flex"
          alignItems="center"
        >
          {title}
        </TextV2>
        <ButtonV2
          onClick={() => handlePriceRangeClick(title, priceRangeQuery)}
          marginTop={pxToRem(2)}
          variant="ghost"
          padding={0}
          height="fit-content"
          width="fit-content"
          color="mono10"
          typographyVariant="label2"
        >
          {shopNow()}
        </ButtonV2>
      </Flex>
    </Box>
  );
};
